<template>
    <v-dialog max-width="800" v-model="dialog" scrollable>
      <v-card>
        <v-card-title class="headline accent">Help</v-card-title>
        <v-card-text>
          <help-text />
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
import helpText from './help-text';

export default {
  props: {
    value: {
      type: Boolean,
    },
  },
  components: { helpText },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
